 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTMLCOVER from '@/components/html/cover'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML9781607056188_03_DED from '@/components/html/9781607056188_03_ded'
 import HTML9781607056188_04_ACK from '@/components/html/9781607056188_04_ack'
 import HTML9781607056188_06_INT from '@/components/html/9781607056188_06_int'
 import HTML9781607056188_07_PT01 from '@/components/html/9781607056188_07_pt01'
 import HTML9781607056188_08_CH01 from '@/components/html/9781607056188_08_ch01'
 import HTML9781607056188_09_CH02 from '@/components/html/9781607056188_09_ch02'
 import HTML9781607056188_10_CH03 from '@/components/html/9781607056188_10_ch03'
 import HTML9781607056188_11_CH04 from '@/components/html/9781607056188_11_ch04'
 import HTML9781607056188_12_PT02 from '@/components/html/9781607056188_12_pt02'
 import HTML9781607056188_13_CH05 from '@/components/html/9781607056188_13_ch05'
 import HTML9781607056188_14_CH06 from '@/components/html/9781607056188_14_ch06'
 import HTML9781607056188_15_CH07 from '@/components/html/9781607056188_15_ch07'
 import HTML9781607056188_16_PT03 from '@/components/html/9781607056188_16_pt03'
 import HTML9781607056188_17_CH08 from '@/components/html/9781607056188_17_ch08'
 import HTML9781607056188_18_CH09 from '@/components/html/9781607056188_18_ch09'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML9781607056188_19_RES from '@/components/html/9781607056188_19_res'
 import HTML9781607056188_20_AUTH from '@/components/html/9781607056188_20_auth'
 import HTML9781607056188_21_BM01 from '@/components/html/9781607056188_21_bm01'
 import HTML9781607056188_22_BM02 from '@/components/html/9781607056188_22_bm02'
 import HTML9781607056188_23_BM03 from '@/components/html/9781607056188_23_bm03'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/cover",
 			"name" : "html/cover",
 			"component" : HTMLCOVER
 		},
 		{
 			"path" : "/html/love_1",
 			"name" : "html/love_1",
 			"component" : HTMLLOVE_1
 		},
 		{
 			"path" : "/html/9781607056188_03_ded",
 			"name" : "html/9781607056188_03_ded",
 			"component" : HTML9781607056188_03_DED
 		},
 		{
 			"path" : "/html/9781607056188_04_ack",
 			"name" : "html/9781607056188_04_ack",
 			"component" : HTML9781607056188_04_ACK
 		},
 		{
 			"path" : "/html/9781607056188_06_int",
 			"name" : "html/9781607056188_06_int",
 			"component" : HTML9781607056188_06_INT
 		},
 		{
 			"path" : "/html/9781607056188_07_pt01",
 			"name" : "html/9781607056188_07_pt01",
 			"component" : HTML9781607056188_07_PT01
 		},
 		{
 			"path" : "/html/9781607056188_08_ch01",
 			"name" : "html/9781607056188_08_ch01",
 			"component" : HTML9781607056188_08_CH01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js